export const getIsYokohama = (): boolean => {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  let subdomain = null;

  if (parts.length > 2) {
    subdomain = parts.slice(0, parts.length - 2).join('.');
  }

  return subdomain === 'yokohama' || parts[0] === 'yokohama';
};
